import React from 'react';

const ModuleLoadFailure = ({ reload }) => (
  <div className="p-8">
    {t('lessons.module_load_failure')}{' '}
    <button type="button" onClick={reload} className="u-linkBtn">
      {t('common.retry')}
    </button>
  </div>
);

export default ModuleLoadFailure;
